<form [formGroup]="flagForm" (ngSubmit)="handleSubmit()">
    <div class="tui-row tui-row_sme">
        <div class="tui-col_12">
            <div class="tui-form__row tui-form__row_multi-fields">
                <div class="tui-form__multi-field">
                    <tui-input formControlName="nameControl">
                        Flag Name
                        <input tuiTextfieldLegacy />
                    </tui-input>
                    <tui-error formControlName="nameControl" [error]="[] | tuiFieldError | async" />
                </div>
                <div class="tui-form__multi-field">
                    <tui-input
                        formControlName="keyControl"
                        tuiHintContent="Please enter the unique key for your flag. This is the value that will be returned via API call to your environment."
                    >
                        Flag Key
                        <input tuiTextfieldLegacy />
                    </tui-input>
                    <tui-error formControlName="keyControl" [error]="[] | tuiFieldError | async" />
                </div>
            </div>
            <div class="tui-form__row">
                <tui-textarea formControlName="descriptionControl">Description</tui-textarea>
                <tui-error formControlName="descriptionControl" [error]="[] | tuiFieldError | async" />
            </div>
            <div class="tui-form__row">
                <ffx-label-dropdown-chips
                    [selectedLabelIcons]="flag.labels"
                    (labelIconsOutput)="setLabelIcons($event)"
                ></ffx-label-dropdown-chips>
            </div>
            @if (isEdit$()) {
                <div class="flag-dialog-warning-text">
                    Note: This will update the flag across all environments in this project.
                </div>
            } @else {
                <div class="flag-dialog-warning-text">
                    Note: This will add the flag to all environments in this project. <br />
                    The flag's status will be initialised as 'false'.
                </div>
            }
            <section class="button-section">
                <button
                    appearance="secondary"
                    iconStart="@tui.trash"
                    size="m"
                    tuiButton
                    type="button"
                    class="tui-form__button"
                    (click)="dialogDiscard()"
                >
                    Discard
                </button>
                <button
                    appearance="primary"
                    iconStart="@tui.send"
                    size="m"
                    tuiButton
                    type="submit"
                    class="create-button tui-form__button"
                >
                    {{ isEdit$() ? 'Update' : 'Create' }}
                </button>
            </section>
        </div>
    </div>
</form>
